import React from "react";
import { Button, useNotify, useRecordContext } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import DeleteIcon from "@mui/icons-material/Delete";
import dataProvider from "server/dataProvider";
import { activityRequests } from "api/activityApi";

const DeleteSportScheduleDialog = ({ fetchSportActivities, educationId }) => {
  const record = useRecordContext();
  const notify = useNotify();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      activityRequests.deleteStudentSportActivity(educationId, record?.sportActivityId),
      null,
      "DELETE",
    );
    fetchSportActivities();
    notify("Успешно изтрихте разписанието", { type: "success" });
  };
  return (
    <ConfirmModal
      isForm
      titleContent="Изтрий разписание спорт"
      onConfirm={handleSubmit}
      message="Сигурни ли сте, че искате да изтриете разписанието?"
      triggerButton={
        <Button
          startIcon={<DeleteIcon />}
          variant="contained"
          label="Изтрий"
          sx={{ mr: 2 }}
        />
      }
    />
  );
};

export default DeleteSportScheduleDialog;
